// 梁
import rlModel from "./rlModel";
import store from "@/store/index";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";
class rlSubBeam extends rlModel {
  constructor() {
    super();
    this.componentType = "subBeam";
    // 顶点数据
    this.points = [];
    // this.Name = null;
    // this.m_sectParamData = {}; //截面源数据
    // this.SectData = []; //截面组合数据
    this.m_gridData1ID = {}; //网格数据1
    this.m_gridData2ID = {}; //网格数据2
    this.m_X1 = null;
    this.m_Y1 = null;
    this.m_Z1 = null;
    this.m_X2 = null;
    this.m_Y2 = null;
    this.m_Z2 = null;

    this.Attribute = 2; //默认为一般构件
    this.classTypeName = "rlSubBeam"; // 梁类型
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识
    // this.defaultColor = "#00b4b4"; //默认颜色
    this.Color = "#00FFE5";
    // (this.rlLayer && this.rlLayer[0] && this.rlLayer[0].storey) || "#00b4b4"; //构件颜色
    this.ModelType = "次梁";
    //this.Layer = "rlBeamSeg"; //图层名称
    // this.LinkGuids = null; //能合并为同一条梁的其他梁的guid
    this.m_groupName = "rlSubBeamGroup"; //组名
    // wasm接口方法
    this.getPKPM_subBeamData =
      store.state.globalData.rl_wasm_module.getPKPM_subBeamData;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);

    this.m_gridData1ID = obj.m_gridData1ID; //网格数据1
    this.m_gridData2ID = obj.m_gridData2ID; //网格数据2
    this.m_X1 = obj.m_X1;
    this.m_Y1 = obj.m_Y1;
    this.m_Z1 = obj.m_Z1;
    this.m_X2 = obj.m_X2;
    this.m_Y2 = obj.m_Y2;
    this.m_Z2 = obj.m_Z2;

    this.Color = obj.Color ? obj.Color : "#00b4b4";
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData1ID = obj.m_gridData1ID; //网格数据1
    this.m_gridData2ID = obj.m_gridData2ID; //网格数据2
    this.m_X1 = obj.m_X1;
    this.m_Y1 = obj.m_Y1;
    this.m_Z1 = obj.m_Z1;
    this.m_X2 = obj.m_X2;
    this.m_Y2 = obj.m_Y2;
    this.m_Z2 = obj.m_Z2;
  }
  // 数据转换
  convert() {
    let res = this.getPKPM_subBeamData(
      this.m_sectParamData.Kind,
      this.m_sectParamData.ShapeVal,
      this.m_X1,
      this.m_Y1,
      this.m_Z1,
      this.m_X2,
      this.m_Y2,
      this.m_Z2
      // this.LevelB,
      // this.Height,
    );

    this.getModelDrawData(JSON.parse(res));
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
    }
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    this.points = modelData.Points;
    this.index3dData = modelData["3D"]["3dFaces"]
      .map((item) => item.index)
      .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
  }

  // 克隆方法
  async myClone() {
    let newObj = await super.myClone();
    newObj.m_gridData1ID = this.m_gridData1ID; //网格数据1
    newObj.m_gridData2ID = this.m_gridData2ID; //网格数据2
    newObj.m_X1 = this.m_X1;
    newObj.m_Y1 = this.m_Y1;
    newObj.m_Z1 = this.m_Z1;
    newObj.m_X2 = this.m_X2;
    newObj.m_Y2 = this.m_Y2;
    newObj.m_Z2 = this.m_Z2;

    return newObj;
  }

  // 绘制
  worldDraw(pWorldDraw) {
    // let wObj;
    this.convert();
    if (pWorldDraw.mxObj._is2d) {
      // wObj = this.create2dModel(this.index2dData);
      // wObj.material.color.set(this.Color);
      pWorldDraw.setColor(new THREE.Color(this.Color));
      this.create2dModel(this.index2dData, pWorldDraw);
    }

    this._threeObj = this.create3dModel(
      this.points,
      this.index3dData,
      0.001,
      4
    );

    // this.m_gridData.m_beamId = this.objectId();
    // pWorldDraw.drawEntity(wObj);
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData1ID) data["Grid1Guid"] = this.m_gridData1ID;

    if (this.m_gridData2ID) data["Grid2Guid"] = this.m_gridData2ID;

    data["X1"] = this.m_X1;
    data["Y1"] = this.m_Y1;
    data["Z1"] = this.m_Z1;
    data["X2"] = this.m_X2;
    data["Y2"] = this.m_Y2;
    data["Z2"] = this.m_Z2;

    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData1ID"] = this.m_gridData1ID;
    data["m_gridData2ID"] = this.m_gridData2ID;
    data["X1"] = this.m_X1;
    data["Y1"] = this.m_Y1;
    data["Z1"] = this.m_Z1;
    data["X2"] = this.m_X2;
    data["Y2"] = this.m_Y2;
    data["Z2"] = this.m_Z2;

    return data;
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    this.onDwgIn(obj);
    return true;
  }

  // 删除
  erase() {
    // this.m_JointData ? (this.m_JointData.m_beamId = null) : "";
    super.erase();
  }
}

export { rlSubBeam };
